import { Link } from "react-router-dom";
import styles from "./401.module.css";
import { getCompanySlug } from "./GetAuth";

const Unauthorized = () => {
  const companySlug = getCompanySlug();

  return (<div className={`${styles.container}`}>
    <div className={`${styles.card}`}>
      <h1>401</h1>
      <h2>Unauthorized Access</h2>
      <p>You have no access for this page.</p>
      <Link to={"/" + companySlug + "/dashboard"} className={`${styles.btn}`}>Go Back Dashboard</Link>
    </div>
  </div>);
}

export default Unauthorized;